import script from "./CustomerLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&setup=true&lang=js"

import "./CustomerLocation.vue?vue&type=style&index=0&id=c9fc8c28&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9fc8c28"]])

export default __exports__